import React from 'react'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import Switch from '@mui/material/Switch'
import CaretDownSvg from '../../assets/images/CaretDown.svg'

interface ActivityBudgetFieldProps {
    budget: number
    onBudgetChange: (value: number) => void
    funded: boolean
    onFundedChange: (checked: boolean) => void
}

const ActivityBudgetField: React.FC<ActivityBudgetFieldProps> = ({
    budget,
    onBudgetChange,
    funded,
    onFundedChange,
}) => {
    const [expanded, setExpanded] = React.useState(true)

    return (
        <Accordion
            expanded={expanded}
            onChange={() => setExpanded(!expanded)}
            disableGutters
            elevation={0}
            sx={{ backgroundColor: 'transparent', '&:before': { display: 'none' } }}
        >
            <AccordionSummary
                expandIcon={
                    <Box
                        component="img"
                        src={CaretDownSvg}
                        sx={{
                            width: 20,
                            height: 20,
                            transition: 'transform 0.2s',
                            transform: expanded ? 'rotate(0deg)' : 'rotate(180deg)',
                        }}
                    />
                }
                sx={{
                    px: 0,
                    py: 1,
                    backgroundColor: 'inherit',
                    '& .MuiAccordionSummary-expandIconWrapper': { transform: 'rotate(0deg)' },
                    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': { transform: 'rotate(180deg)' },
                }}
            >
                <Typography variant="18x600">Budget</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 0, pt: 1 }}>
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', justifyContent: 'space-between' }}>
                    <Box>
                        <Typography variant="16x600" sx={{ mb: 1, display: 'block' }}>
                            Funded
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Typography variant="body2">No</Typography>
                            <Switch checked={funded} onChange={(e) => onFundedChange(e.target.checked)} name="funded" />
                            <Typography variant="body2">Yes</Typography>
                        </Box>
                    </Box>
                    <Box sx={{ width: 260 }}>
                        <Typography variant="16x600" sx={{ mb: 1, display: 'block' }}>
                            Budget
                        </Typography>
                        <TextField
                            type="number"
                            fullWidth
                            value={budget}
                            onFocus={(e) => e.target.setAttribute('autocomplete', 'off')}
                            onChange={(e) => onBudgetChange(Number.parseInt(e.target.value))}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">$</InputAdornment>,
                            }}
                            sx={{ '.MuiInputBase-root': { borderRadius: '12px' } }}
                        />
                    </Box>
                </Box>
            </AccordionDetails>
        </Accordion>
    )
}

export default ActivityBudgetField
